import { createContext, FC, ReactNode, useContext, useMemo, useState, useCallback } from 'react';
import { ExecuteDataT } from '~/components/payment-beta/types/deposit';
import { JSONObject } from '~/components/payment-beta/types';

type ExecuteValueT = {
	flow: string;
	data: ExecuteDataT;
	actions?: ActionT;
};
export type ExecuteContextT = ExecuteValueT & {
	updateExecuteData: (data: ExecuteDataT) => void;
};

type ActionT = {
	onClose?: (cb: void) => void;
	onSuccess?: (obj: JSONObject) => void;
};

export interface ExecuteProviderProps {
	value: ExecuteValueT;
	children: ReactNode;
}

const ExecuteContext = createContext<ExecuteContextT>({} as ExecuteContextT);

export const useExecuteContext = () => useContext(ExecuteContext);

const ExecuteContextProvider: FC<ExecuteProviderProps> = ({ children, value }) => {
	const [contextValue, updateValue] = useState(value);

	const updateExecuteData = useCallback((data: ExecuteDataT) => updateValue({ ...value, data }), [value]);

	const context = useMemo(() => ({ ...contextValue, updateExecuteData }), [contextValue, updateExecuteData]);

	return <ExecuteContext.Provider value={context}>{children}</ExecuteContext.Provider>;
};

export default ExecuteContextProvider;
